import type { SchemaToType } from '@main/schema-utils';
import { mkType } from '@main/schema-utils';

import { FeatureDefinitionName, FeatureStatus, FeatureType } from './enums';

/**
 *
 *Set of Features an organization can make use of
 */
export const FeatureDefinition = mkType({
  name: 'FeatureDefinition',
  comment: 'A definition of a feature that can be enabled/disabled/configured',
  fields: {
    id: {
      comment: 'The id of the feature definition.',
      type: 'id',
      modelName: 'featureDefinition',
    },
    featureName: {
      comment: 'The name of the feature.',
      type: { FeatureDefinitionName },
    },
    status: {
      comment: 'The maturity status of the feature.',
      type: { FeatureStatus },
    },
    type: {
      comment: 'The type of the feature.',
      type: { FeatureType },
    },
  },
});

/** Override type */
export type FeatureDefinition = SchemaToType<typeof FeatureDefinition>;
